module.exports = (Vue) => {
	Vue.directive('intersecting', require('./intersecting'));
	Vue.directive('click-outside',  require('./clickOutside'))
};
